import type { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Spec 079 (FR-031/FR-040) — o CAMPO de um parâmetro de política.
//
// Existe porque são DEZ campos com a mesma anatomia, e escrevê-la dez vezes garantiria que um deles
// acabasse sem a frase que explica o que ele decide — que é justamente o que a FR-031 exige.
//
// ⚠️ A `hint` diz O QUE O NÚMERO DECIDE, nunca o que ele é. "Acurácia mínima para confiança alta"
// é o rótulo; "acima dela o chip da simulação exibe Alta" é a informação. Um gestor que não sabe o
// efeito não tem como escolher o valor, e o campo vira um número que ninguém ousa mexer.
//
// ⚠️ `type="number"` com `valueAsNumber` no `register` do chamador. Sem ele o formulário entrega
// string, o Zod recusa com "esperado número" e o erro aparece num campo que o gestor preencheu
// certo.

export interface PolicyFieldProps {
  id: string;
  label: string;
  /** O que este número DECIDE — não o que ele é. */
  hint: string;
  /** Sufixo da unidade ("%", "h", "compromissos"). */
  unit: string;
  registration: UseFormRegisterReturn;
  error?: FieldError;
  disabled: boolean;
  step?: string;
}

export function PolicyField({
  id,
  label,
  hint,
  unit,
  registration,
  error,
  disabled,
  step = "1",
}: PolicyFieldProps) {
  const describedBy = `${id}-hint${error ? ` ${id}-error` : ""}`;
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{label}</Label>
      <div className="flex items-center gap-2">
        <Input
          id={id}
          type="number"
          step={step}
          inputMode="decimal"
          placeholder="0"
          disabled={disabled}
          aria-describedby={describedBy}
          aria-invalid={error ? true : undefined}
          className="w-28"
          {...registration}
        />
        <span className="text-[12px] text-text-tertiary">{unit}</span>
      </div>
      <p id={`${id}-hint`} className="text-[12px] leading-tight text-text-secondary">
        {hint}
      </p>
      {/* O erro do par ordenado ancora NESTE campo (o maior do par) — é o que faz a mensagem
          aparecer sob um input em vez de sumir no topo do formulário. */}
      {error ? (
        <p id={`${id}-error`} role="alert" className="text-[12px] leading-tight text-rd-danger-600">
          {error.message}
        </p>
      ) : null}
    </div>
  );
}
